import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import useSeo from '@/hooks/useSeo';

const HERO = 'https://readdy.ai/api/search-image?query=Extremely%20realistic%20professional%20industrial%20photography%20modern%20clean%20organized%20heavy%20industrial%20workshop%20with%20large%20machinery%20hydraulic%20equipment%20steel%20components%20metallic%20surfaces%20professional%20technicians%20in%20safety%20gear%20working%20not%20facing%20camera%20cinematic%20dramatic%20lighting%20gray%20silver%20steel%20tones%20with%20subtle%20warm%20yellow%20accent%20details%20wide%20angle%20widescreen%20composition%20premium%20high%20resolution%20sharp%20depth%20industrial%20maintenance%20engineering%20reliability%20heavy%20mechanics%20pulp%20paper%20mining%20oil%20gas%20sectors%20negative%20space%20for%20title%20overlay%20clean%20backgrounds%20not%20stock%20photo%20not%20illustration%20not%203D%20render&width=1600&height=700&seq=gp-cases-unified-hero-v2&orientation=landscape';
const CARCACA = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/16b4d637-be1b-4e0d-a862-f51985e49565_compressed_CARCACA-PORTA-PISTAO-BOMBA-PISTAO.webp';
const KIT = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/21f5abb8-d61a-4602-ad49-d56d047f5702_compressed_KIT-VEDACAO-BOMBA-PISTAO.webp';
const JUNTA = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/59ff026e-c3f0-40b1-ad16-8f568e15612e_compressed_JUNTA-BOMBA-PISTAO.webp';
const PISTOES = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/23e2ac68-64e9-4afc-90fd-2cda49a36fe3_compressed_PISTOES-NOVOS-BOMBA-DE-PISTAO.webp';
const MOLA = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/8f770c60-1981-471d-ac15-6211f0645526_compressed_MOLA-AJUSTE-BOMBA-PISTAO.webp';
const MONTAGEM_BOMBA = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/25470c8e-f885-45d5-94a0-5c361d2432bb_compressed_INICIO-MONTAGEM-BOMBA-PISTAO.webp';
const MONTAGEM_MOTOR = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/8111f987-b633-4c57-937c-61568dfb0a39_compressed_INICIO-MONTAGEM-MOTOR.webp';

export default function CaseRecuperacaoBombasPistaoHidraulicasPage() {
  useSeo({
    title: 'Recuperação de Bombas de Pistão Hidráulicas | Oficina Especializada | Grupo Pilar',
    description: 'Serviço especializado de recuperação de bombas hidráulicas de pistão, incluindo desmontagem, inspeção técnica, substituição de componentes internos, lapidação e montagem especializada.',
    keywords: 'bomba de pistão hidráulica, recuperação de bomba hidráulica, manutenção de bomba hidráulica, bomba hidráulica industrial, hidráulica industrial, reparo de bomba hidráulica, oficina especializada, grupo pilar',
    canonical: 'https://www.pilarmanutencao.com.br/cases/recuperacao-bombas-pistao-hidraulicas',
    ogUrl: 'https://www.pilarmanutencao.com.br/cases/recuperacao-bombas-pistao-hidraulicas',
    ogImage: HERO,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const heroImage = HERO;

  return (
    <div className="min-h-screen bg-gp-graphite">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative min-h-[60vh] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src={heroImage}
              alt="Bomba de pistão hidráulica industrial recuperada pela Pilar — desmontagem, inspeção técnica, substituição de conjunto rotativo, pistões, molas, vedações, o-rings, juntas, anéis de deslizamento, lapidação de componentes e montagem especializada com validação operacional"
              title="Recuperação de Bombas de Pistão Hidráulicas Industriais — Case Pilar"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gp-graphite/75"></div>
          </div>
          <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12 pt-28 pb-16">
            <div className="max-w-4xl">
              <div className="flex items-center gap-3 mb-6 flex-wrap">
                <span className="inline-block px-3 py-1 rounded-sm text-xs font-semibold uppercase tracking-wider bg-gp-yellow text-gp-graphite">
                  Oficina Especializada
                </span>
                <span className="text-gray-400 text-xs uppercase tracking-wider">Hidráulica Industrial</span>
                <span className="text-gray-500 text-xs">— Aracruz, ES</span>
              </div>
              <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white uppercase leading-tight mb-6">
                <span className="text-gp-yellow">Case:</span>{' '}
                Recuperação de Bombas de Pistão Hidráulicas Industriais
              </h1>
              <p className="text-gray-300 text-lg max-w-2xl leading-relaxed">
                Recuperação completa de bombas hidráulicas de pistão utilizadas em aplicações industriais
                de alta criticidade. Os serviços incluem desmontagem, inspeção técnica detalhada,
                substituição de componentes de desgaste — incluindo conjunto rotativo, pistões, molas,
                vedações, o-rings e anéis de deslizamento — lapidação de componentes quando tecnicamente
                aplicável, recuperação de peças de alto valor agregado, montagem especializada e validação
                funcional completa do equipamento.
              </p>
            </div>
          </div>
        </section>

        {/* Visão Geral */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Visão Geral</h2>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-information-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Dados do Projeto</h3>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-settings-3-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Equipamento</span>
                        <p className="text-gray-300 text-sm">Bombas Hidráulicas de Pistão para Sistemas Industriais de Alta Pressão</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-building-2-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Segmento</span>
                        <p className="text-gray-300 text-sm">Hidráulica Industrial</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-tools-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Aplicação</span>
                        <p className="text-gray-300 text-sm">Bombas hidráulicas de pistão utilizadas em sistemas hidráulicos industriais de alta pressão</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-speed-up-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Tipo de Intervenção</span>
                        <p className="text-gray-300 text-sm">Recuperação completa com desmontagem, inspeção, substituição de componentes e validação funcional</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-bar-chart-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Diferencial do Projeto</span>
                        <p className="text-gray-300 text-sm">Recuperação de componentes de alto valor agregado com redução de custos em comparação à substituição completa</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite">
                  <img
                    src={CARCACA}
                    alt="Componentes principais da bomba hidráulica durante inspeção e recuperação especializada"
                    title="Componentes principais da bomba de pistão hidráulica — oficina Pilar"
                    className="w-full h-80 md:h-[28rem] object-contain"
                    loading="lazy"
                  />
                  <div className="bg-gp-graphite-light p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Componentes principais da bomba hidráulica durante inspeção e recuperação especializada
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Desafio */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Desafio</h2>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-alert-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-gray-300 text-base leading-relaxed mb-4">
                        A Pilar executa a recuperação completa de bombas hidráulicas de pistão utilizadas em
                        aplicações industriais de alta criticidade. Esses equipamentos operam com tolerâncias
                        dimensionais extremamente reduzidas e são submetidos a condições severas de pressão,
                        vazão e ciclos de trabalho contínuos, exigindo conhecimento técnico especializado e
                        controle rigoroso durante todas as etapas do processo de recuperação.
                      </p>
                      <p className="text-gray-400 text-sm leading-relaxed mb-4">
                        As principais complexidades envolviam:
                      </p>
                      <ul className="space-y-2 mb-4">
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Equipamentos de alta precisão com tolerâncias dimensionais mínimas entre componentes internos</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Componentes sujeitos a desgaste severo devido a altas pressões e ciclos contínuos de operação</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Necessidade de inspeção detalhada de todos os componentes internos do conjunto rotativo</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Controle rigoroso de montagem com verificação de folgas, torque e alinhamentos</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Alta exigência operacional dos sistemas hidráulicos industriais onde as bombas atuam</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite">
                  <img
                    src={KIT}
                    alt="Equipamento apresentando desgaste interno e necessidade de substituição dos componentes de vedação"
                    title="Kit de vedação da bomba de pistão hidráulica — componentes de reposição"
                    className="w-full h-80 md:h-[28rem] object-contain"
                    loading="lazy"
                  />
                  <div className="bg-gp-graphite-light p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Equipamento apresentando desgaste interno e necessidade de substituição dos componentes de vedação
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Escopo Executado */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Escopo Executado pela Pilar</h2>
              </div>

              <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite mb-8">
                <img
                  src={PISTOES}
                  alt="Instalação de novos pistões durante o processo de recuperação da bomba hidráulica"
                  title="Substituição de pistões da bomba de pistão hidráulica"
                  className="w-full h-80 md:h-[28rem] object-contain"
                  loading="lazy"
                />
                <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                  <p className="text-gray-400 text-xs text-center">
                    Instalação de novos pistões durante o processo de recuperação da bomba hidráulica
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">01</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Desmontagem completa da bomba de pistão hidráulica na oficina especializada Pilar</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">02</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Peritagem técnica completa de todos os componentes com relatório de avaliação detalhado</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">03</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Inspeção dimensional detalhada de todos os componentes internos com instrumentação de precisão</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">04</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Limpeza técnica de todos os componentes com remoção de contaminantes e resíduos</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">05</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Avaliação detalhada dos componentes internos da bomba: bloco de cilindros, placa de desgaste e placa de válvulas</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">06</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição de rolamentos conforme diagnóstico técnico das inspeções realizadas</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">07</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição do conjunto rotativo da bomba de pistão com componentes dimensionados para a aplicação</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">08</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição de pistões com verificação dimensional e ajuste de folgas conforme especificação</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">09</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição de molas com verificação de compressão e conformidade dimensional</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">10</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição completa de vedações: selos, retentores, gaxetas e anéis de vedação</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">11</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição de o-rings em todas as conexões e interfaces de vedação da bomba</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">12</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição de juntas de vedação em todas as superfícies de contato da carcaça</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">13</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição de anéis de deslizamento com verificação de planicidade e ajuste dimensional</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">14</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição completa de componentes de desgaste identificados durante as inspeções técnicas</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Recuperação e Ajustes */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Recuperação e Ajustes</h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start mb-8">
                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-tools-fill text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Atividades de Recuperação</h3>
                    </div>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed mb-4">
                    Além da substituição de componentes de desgaste, a Pilar executa a recuperação de peças
                    de alto valor agregado que podem ser recondicionadas tecnicamente. Essas atividades
                    demandam conhecimento técnico especializado e controle dimensional rigoroso para
                    garantir que os componentes recuperados atendam às especificações originais do
                    fabricante.
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Inspeção detalhada dos blocos de cilindros com verificação de desgastes nos alojamentos dos pistões</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Inspeção das placas de desgaste com verificação de planicidade e condições da superfície de contato</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Inspeção dos conjuntos móveis com avaliação de desgastes e folgas operacionais</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Lapidação de componentes quando tecnicamente aplicável para recuperação de superfícies de contato</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Recuperação de componentes aproveitáveis com recondicionamento dimensional e funcional</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Montagem especializada com controle dimensional, verificação de folgas e ajustes de precisão</span>
                    </li>
                  </ul>
                </div>

                <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite">
                  <img
                    src={MOLA}
                    alt="Substituição e ajuste dos componentes internos responsáveis pelo funcionamento da bomba"
                    title="Mola de ajuste da bomba de pistão hidráulica"
                    className="w-full h-80 md:h-[28rem] object-contain"
                    loading="lazy"
                  />
                  <div className="bg-gp-graphite-light p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Substituição e ajuste dos componentes internos responsáveis pelo funcionamento da bomba
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Validação */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Validação</h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-double-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <span className="text-gp-yellow font-semibold text-sm block mb-1">Verificações Funcionais</span>
                    <p className="text-gray-300 text-sm leading-relaxed">Verificações funcionais completas de todos os sistemas e componentes da bomba de pistão após montagem</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-search-eye-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <span className="text-gp-yellow font-semibold text-sm block mb-1">Inspeções Finais</span>
                    <p className="text-gray-300 text-sm leading-relaxed">Inspeções finais de todos os componentes montados com verificação de torque, folgas e alinhamentos</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-rocket-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <span className="text-gp-yellow font-semibold text-sm block mb-1">Preparação para Retorno</span>
                    <p className="text-gray-300 text-sm leading-relaxed">Preparação para retorno à operação com todos os procedimentos de liberação concluídos</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-test-tube-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <span className="text-gp-yellow font-semibold text-sm block mb-1">Validação Operacional</span>
                    <p className="text-gray-300 text-sm leading-relaxed">Validação operacional através de processo de testes compatível com a aplicação industrial</p>
                  </div>
                </div>
              </div>

              <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite">
                <img
                  src={MONTAGEM_BOMBA}
                  alt="Montagem inicial dos conjuntos internos após conclusão da inspeção e substituição dos componentes"
                  title="Montagem inicial da bomba de pistão hidráulica"
                  className="w-full h-80 md:h-[28rem] object-contain"
                  loading="lazy"
                />
                <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                  <p className="text-gray-400 text-xs text-center">
                    Montagem inicial dos conjuntos internos após conclusão da inspeção e substituição dos componentes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Resultados */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Resultados</h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <span className="text-gp-yellow font-semibold text-sm block mb-1">Equipamento Recuperado</span>
                    <p className="text-gray-300 text-sm leading-relaxed">Recuperação completa da bomba de pistão hidráulica com retorno às condições operacionais originais</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-arrow-go-back-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <span className="text-gp-yellow font-semibold text-sm block mb-1">Retorno à Operação</span>
                    <p className="text-gray-300 text-sm leading-relaxed">Retorno seguro à operação no sistema hidráulico industrial com desempenho validado</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <span className="text-gp-yellow font-semibold text-sm block mb-1">Maior Confiabilidade</span>
                    <p className="text-gray-300 text-sm leading-relaxed">Maior confiabilidade operacional do sistema hidráulico com redução de riscos de falhas</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-money-dollar-circle-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <span className="text-gp-yellow font-semibold text-sm block mb-1">Redução de Custos</span>
                    <p className="text-gray-300 text-sm leading-relaxed">Redução de custos em comparação à substituição completa da bomba de pistão hidráulica</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-arrow-up-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <span className="text-gp-yellow font-semibold text-sm block mb-1">Vida Útil Ampliada</span>
                    <p className="text-gray-300 text-sm leading-relaxed">Ampliação da vida útil dos componentes com recuperação técnica especializada</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-recycle-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <span className="text-gp-yellow font-semibold text-sm block mb-1">Recuperação de Alto Valor</span>
                    <p className="text-gray-300 text-sm leading-relaxed">Recuperação de componentes de alto valor agregado com recondicionamento técnico especializado</p>
                  </div>
                </div>
              </div>

              <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite">
                <img
                  src={MONTAGEM_MOTOR}
                  alt="Etapa final de montagem e preparação da bomba para validação operacional"
                  title="Montagem final da bomba de pistão hidráulica"
                  className="w-full h-80 md:h-[28rem] object-contain"
                  loading="lazy"
                />
                <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                  <p className="text-gray-400 text-xs text-center">
                    Etapa final de montagem e preparação da bomba para validação operacional
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Diferenciais da Pilar */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Diferenciais da Pilar</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-settings-3-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Experiência consolidada em hidráulica industrial com conhecimento profundo de sistemas de alta pressão</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-tools-fill text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Capacidade de recuperação completa de bombas de pistão hidráulicas na oficina especializada Pilar</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-search-eye-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Inspeção técnica especializada com peritagem detalhada e relatório de avaliação dos componentes</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-stack-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Recuperação de componentes de alto valor agregado com recondicionamento técnico qualificado</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-team-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Equipe especializada em sistemas hidráulicos industriais com conhecimento em bombas de pistão</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-test-tube-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Estrutura completa para desmontagem, inspeção, lapidação, montagem e testes de bombas hidráulicas</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Galeria Técnica */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Galeria Técnica</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {/* Foto 1 — Pistões Novos */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={PISTOES}
                      alt="Instalação de novos pistões durante o processo de recuperação da bomba hidráulica"
                      title="Pistões novos da bomba de pistão hidráulica"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 1</span>
                  </div>
                </div>
                {/* Foto 2 — Mola */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={MOLA}
                      alt="Substituição e ajuste dos componentes internos responsáveis pelo funcionamento da bomba"
                      title="Mola de ajuste da bomba de pistão hidráulica"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 2</span>
                  </div>
                </div>
                {/* Foto 3 — Kit Vedação */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={KIT}
                      alt="Equipamento apresentando desgaste interno e necessidade de substituição dos componentes de vedação"
                      title="Kit de vedação da bomba de pistão hidráulica"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 3</span>
                  </div>
                </div>
                {/* Foto 4 — Junta */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={JUNTA}
                      alt="Avaliação técnica dos componentes internos para definição do escopo de recuperação"
                      title="Juntas de vedação da bomba de pistão hidráulica"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 4</span>
                  </div>
                </div>
                {/* Foto 5 — Montagem Motor */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={MONTAGEM_MOTOR}
                      alt="Etapa final de montagem e preparação da bomba para validação operacional"
                      title="Montagem final do motor da bomba de pistão hidráulica"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 5</span>
                  </div>
                </div>
                {/* Foto 6 — Montagem Bomba */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={MONTAGEM_BOMBA}
                      alt="Montagem inicial dos conjuntos internos após conclusão da inspeção e substituição dos componentes"
                      title="Início da montagem da bomba de pistão hidráulica"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 6</span>
                  </div>
                </div>
                {/* Foto 7 — Carcaça */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={CARCACA}
                      alt="Componentes principais da bomba hidráulica durante inspeção e recuperação especializada"
                      title="Carcaça e porta-pistão da bomba de pistão hidráulica"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 7</span>
                  </div>
                </div>
                {/* Foto 8 — Finalizado */}
                <div className="relative rounded-lg border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-64 md:h-72 flex items-center justify-center">
                    <img
                      src={HERO}
                      alt="Bomba hidráulica recuperada pela Pilar e preparada para retorno à operação industrial"
                      title="Bomba de pistão hidráulica finalizada — resultado Pilar"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 8</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Serviços Relacionados */}
        <section className="relative py-16 overflow-hidden border-t border-gp-graphite-lighter">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-lg font-bold text-white uppercase tracking-wider">Serviços Relacionados</h2>
              </div>
              <div className="flex flex-wrap gap-3">
                <Link
                  to="/hidraulica-industrial"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Hidráulica Industrial
                </Link>
                <Link
                  to="/mecanica-industrial"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Mecânica Industrial
                </Link>
                <Link
                  to="/recuperacao-bombas-hidraulicas"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Recuperação de Bombas Hidráulicas
                </Link>
                <Link
                  to="/oficina"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Oficina Especializada
                </Link>
                <Link
                  to="/cases"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Mais Cases de Sucesso
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="relative py-20 bg-gp-graphite-light overflow-hidden">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="relative rounded-xl overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-gp-yellow/20 to-gp-graphite"></div>
              <div className="absolute inset-0 bg-gp-graphite/60"></div>
              <div className="relative z-10 p-8 md:p-12 text-center">
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase mb-4">
                  Suas bombas de pistão precisam de recuperação especializada?
                </h2>
                <p className="text-gray-300 max-w-2xl mx-auto mb-8 leading-relaxed">
                  Conte com a experiência da Pilar em hidráulica industrial para recuperar suas bombas de
                  pistão hidráulicas. Executamos desmontagem, inspeção técnica, substituição de
                  componentes internos, lapidação e montagem especializada — com validação funcional
                  completa antes do retorno à operação. Reduza custos em comparação à substituição
                  completa e amplie a vida útil dos seus equipamentos.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <a
                    href="https://wa.me/5527993092922"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 bg-gp-yellow hover:bg-gp-yellow-dark text-gp-graphite px-8 py-4 rounded-full font-semibold text-sm uppercase tracking-wider transition-all duration-300 hover:scale-105 whitespace-nowrap"
                  >
                    <div className="w-10 h-10 bg-gp-graphite rounded-full flex items-center justify-center">
                      <i className="ri-whatsapp-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <span>Solicitar Recuperação</span>
                    <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
                  </a>
                  <Link
                    to="/contato"
                    className="inline-flex items-center justify-center gap-2 border border-gray-500 hover:border-gp-yellow text-gray-300 hover:text-gp-yellow px-8 py-4 rounded-full font-semibold text-sm transition-all duration-300 whitespace-nowrap"
                  >
                    <i className="ri-mail-line text-lg w-6 h-6 flex items-center justify-center"></i>
                    Falar com Especialista
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Back to Cases */}
        <section className="py-10 border-t border-gp-graphite-lighter">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <Link
                to="/cases"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-gp-yellow transition-colors duration-300 text-sm uppercase tracking-wider"
              >
                <i className="ri-arrow-left-line w-5 h-5 flex items-center justify-center"></i>
                Voltar para Cases
              </Link>
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-gp-yellow transition-colors duration-300 text-sm uppercase tracking-wider"
              >
                <i className="ri-home-line w-5 h-5 flex items-center justify-center"></i>
                Voltar para Home
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />

      {/* Schema JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: 'Recuperação de Bombas de Pistão Hidráulicas Industriais | Case Grupo Pilar',
            description: 'Serviço especializado de recuperação de bombas hidráulicas de pistão, incluindo desmontagem, inspeção técnica, substituição de componentes internos, lapidação e montagem especializada.',
            image: heroImage,
            author: {
              '@type': 'Organization',
              name: 'Grupo Pilar',
              url: 'https://www.pilarmanutencao.com.br',
            },
            publisher: {
              '@type': 'Organization',
              name: 'Grupo Pilar',
              logo: {
                '@type': 'ImageObject',
                url: '/images/MARCA/LOGO-GRUPO-PILAR/LOGO-GRUPO-PILAR.png',
              },
            },
            datePublished: '2025-12-08',
            dateModified: '2026-06-23',
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': 'https://www.pilarmanutencao.com.br/cases/recuperacao-bombas-pistao-hidraulicas',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: 'https://www.pilarmanutencao.com.br',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'Cases de Sucesso',
                item: 'https://www.pilarmanutencao.com.br/cases',
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: 'Recuperação de Bombas de Pistão Hidráulicas Industriais',
                item: 'https://www.pilarmanutencao.com.br/cases/recuperacao-bombas-pistao-hidraulicas',
              },
            ],
          }),
        }}
      />
    </div>
  );
}